import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { shopActions } from "@hopper-b2b/flights";
import { Box, FormControlLabel, Checkbox, Typography } from "@material-ui/core";
import clsx from "clsx";

export type FlightFintechSelectionDecline = {
  title: string;
  description: string;
  checked?: boolean;
  disabled: boolean;
  setChecked?: (checked: boolean) => void;
};

export const FlightFintechSelectionDecline = ({
  title,
  description,
  disabled,
  setChecked: setParentChecked,
}: FlightFintechSelectionDecline) => {
  const dispatch = useDispatch();

  const [checked, setChecked] = useState<boolean>(false);

  const onChange = useCallback(
    (_event, isChecked: boolean) => {
      if (isChecked) {
        setParentChecked(isChecked);
        dispatch(shopActions.setDeclineAllFintechOptions(true));
      } else {
        dispatch(shopActions.setDeclineAllFintechOptions(false));
      }

      setChecked(isChecked);
    },
    [dispatch, setParentChecked]
  );

  return (
    <Box
      my={2}
      pr={4}
      className={clsx("fintech-selection-card", {
        "fintech-selection-card--decline-card": true,
        selected: checked,
      })}
    >
      <FormControlLabel
        labelPlacement="start"
        disabled={disabled}
        control={
          <Checkbox
            className="checkbox"
            checked={checked}
            onChange={onChange}
            color="default"
          />
        }
        label={
          <Box mr={2} className="fintech-label">
            <Box>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                {title}
              </Typography>
              <Typography variant="caption" className="fintech-description">
                {description}
              </Typography>
            </Box>
          </Box>
        }
      />
    </Box>
  );
};
